import { API, graphqlOperation } from 'aws-amplify';

import { handleHttpErrorResponse } from '@/modules/api';

export const fetchData = <TData, TVariables>(
    operation: string,
    variables?: TVariables,
): (() => Promise<TData>) => {
    return async () => {
        const newOperation = graphqlOperation(operation, variables ?? {});

        try {
            // TODO: followup, handle subscription case
            const res = (await API.graphql<TData>(newOperation)) as { data: TData };
            return res.data;
        } catch (err) {
            // @ts-ignore TODO: followup, improve this, it is carried over from @/modules/api
            await handleHttpErrorResponse(err);
        }
        return {} as TData; // with an improved handleHttpErrorResponse function, this will not be generally available
    };
};
